import {ServiceNotification} from '@/utils/notifications/emails/entities/service/constants'

export enum ServiceType {
  ceaseAndDesist = 'Cease & Desist',
  domainDispute = 'Domain dispute',
  cancellation = 'Cancellation',
  negotiations = 'Negotiations',
  opposition = 'Opposition',
  takedown = 'Takedown',
  warningLetter = 'Warning letter',
  legalConsultation = 'Legal consultation',
  usLetterOfProtest = 'US Letter of protest',
}

export enum ServiceStatus {
  created = 'Created',
  communicationInProgress = 'Communication in progress',
  inProgress = 'In progress',
  takedownRequested = 'Takedown requested',
  submittedToIpo = 'Submitted to IPO',
  done = 'Done',
}

export enum ServiceAction {
  invoicePaid = 'Invoice paid',
}

export enum ServiceTrackingActionId {
  communicationInProgress = 'communicationInProgress',
  inProgress = 'inProgress',
  submittedToIpo = 'submittedToIpo',
  takedownRequested = 'takedownRequested',
  finish = 'finish',
}

export enum ServiceOutcome {
  success = 'Success',
  partialSuccess = 'Partial success',
  fail = 'Fail',
  dismiss = 'Dismiss',
}

export const takedownNotificationMap: Partial<Record<ServiceOutcome, ServiceNotification>> = {
  [ServiceOutcome.success]: ServiceNotification.takedownSuccessful,
  [ServiceOutcome.fail]: ServiceNotification.takedownFailed,
} as const
